import React from "react";
import { Redirect } from "react-router-dom";
import { hasRole } from "../../utils/routeAuth";

interface ProtectedRouteProps {
  isLoggedIn: boolean;
  /** Verilmezse yalnızca oturum kontrolü yapılır. */
  role?: string | null;
  redirectPath: string;
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  isLoggedIn,
  role,
  redirectPath,
  children,
}) => {
  if (!isLoggedIn) {
    return <Redirect to={redirectPath} />;
  }

  if (role && !hasRole(localStorage.getItem("roles"), role)) {
    return <Redirect to="/" />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
